import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateRemoveModerationVacancy = {
  removeModerationVacancy: { data: null, loading: false, error: null },
};

export const removeModerationVacancy = createAsyncThunk('user/removeModerationVacancy', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerRemoveModerationVacancy = {
  [removeModerationVacancy.pending]: (state) => {
    state.removeModerationVacancy.loading = true;
    state.removeModerationVacancy.error = null;
  },
  [removeModerationVacancy.fulfilled]: (state, action) => {
    state.removeModerationVacancy.loading = false;
    state.removeModerationVacancy.data = true;
    state.removeModerationVacancy.error = null;
  },
  [removeModerationVacancy.rejected]: (state, action) => {
    state.removeModerationVacancy.loading = false;
    state.removeModerationVacancy.error = action.payload;
  },
};
